require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./flexlayout"), require("./constants"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./truncatedtext", "./flexlayout", "./constants"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./flexlayout"), require("./constants")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./truncatedtext"], root["./flexlayout"], root["./constants"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__27__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[35],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-list{padding:0;margin:0;display:block;max-height:100%;overflow-y:auto;overflow-x:hidden;flex-shrink:1;will-change:scroll-position;touch-action:manipulation;cursor:default;user-select:none}.ba-common-list:focus{outline:none}.ba-common-list .ba-common-listItem-wrapper.is-focus{box-shadow:inset 0 0 0 2px #a8c0f3;box-shadow:inset 0 0 0 2px hsl(var(--focus-h, 221), var(--focus-s, 76%), var(--focus-l, 81%))}", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-menu\""
};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".mobile .ba-common-listItem{min-height:40px;min-width:100%}.ba-common-listItem{background-color:transparent;position:relative;min-height:32px;padding-left:16px;padding-right:16px}.ba-common-listItem:before{content:\"\";min-height:32px;visibility:hidden;width:0}.ba-common-listItem.is-hoveredBelow:after{content:\"\";position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;bottom:-1px}.ba-common-listItem.is-hoveredAbove:after{content:\"\";position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;top:-1px}.ba-common-listItem.is-hoveredCenter{outline:2px solid;border-right-width:2px;padding-right:6px;border-left-width:2px;padding-left:6px}.ba-common-listItem.is-separator:after{content:\"\";height:1px;border-width:0;border-bottom-width:1px;border-style:solid;margin:0 8px 0 8px;left:0;bottom:0;right:0;position:absolute}.ba-common-listItem__cmBtn,.ba-common-listItem__iconBtn{visibility:hidden}[dir=ltr].ba-common-listItem__cmBtn,.ba-common-listItem__iconBtn{margin-right:-8px}[dir=rtl].ba-common-listItem__cmBtn,.ba-common-listItem__iconBtn{margin-right:0;margin-left:-8px}[dir=ltr] .ba-common-listItem__cmBtn,.ba-common-listItem__cmBtn,[dir=ltr] .ba-common-listItem__iconBtn,.ba-common-listItem__iconBtn{margin-right:-8px}[dir=rtl] .ba-common-listItem__cmBtn,[dir=rtl] .ba-common-listItem__iconBtn{margin-right:0;margin-left:-8px}.ba-common-listItem__cmBtn.is-listItemFocus{visibility:visible}[dir=ltr].ba-common-listItem__iconBtn{margin-left:8px}[dir=rtl].ba-common-listItem__iconBtn{margin-left:0;margin-right:8px}[dir=ltr] .ba-common-listItem__iconBtn,.ba-common-listItem__iconBtn{margin-left:8px}[dir=rtl] .ba-common-listItem__iconBtn{margin-left:0;margin-right:8px}.ba-common-listItem button[data-tid=ba-common-listItem__context-menu]{border-color:transparent !important;color:inherit;outline:none !important}.ba-common-listItem button[data-tid=ba-common-listItem__context-menu] span,.ba-common-listItem button[data-tid=ba-common-listItem__context-menu] div{display:none !important}.ba-common-listItem button[data-tid=ba-common-listItem__context-menu]::before{display:none !important}.ba--focusable:focus div:last-child>.ba-common-listItem.is-separator:after{border-bottom-width:0px}.list-item-children{display:flex;width:100%;align-items:center}.ba-common-listItem:not(.is-active){background-color:#fff;box-shadow:inset 0 0 0 1px transparent}.ba-common-listItem:not(.is-active) [type=button]:focus{background-color:transparent;box-shadow:inset 0 0 0 1px transparent}.ba-common-listItem.is-active{background-color:transparent;box-shadow:inset 0px 0 0 2px #0f62fe}.ba-common-listItem.is-active [type=button]:hover{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,inset 0 -2px 0 0 transparent}.ba-common-listItem.is-active [type=button]:focus{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,inset 0 -2px 0 0 transparent}.ba-common-listItem.is-active [type=button]:active{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,inset 0 -2px 0 0 transparent}.ba-common-listItem.is-active.is-selected{background-color:#e5e5e5;box-shadow:inset 0 0 0 2px #0f62fe}.ba-common-listItem.is-active.is-selected:hover{background-color:#cacaca}.ba-common-listItem.is-active.is-selected [type=button]:focus{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,inset 0 -2px 0 0 transparent}.selection-mark .ba-common-listItem.is-active.is-selected{box-shadow:inset 4px 0 0 0 #0f62fe,inset 0 0 0 2px #0f62fe}.ba-common-listItem.is-selected{border-color:#1f57a4;border-color:hsla(var(--primary1-h, 214.7368421053), var(--primary1-s, 68.2051282051%), var(--primary1-l, 38.2352941176%), 1);background-color:#e0e0e0;color:#343334}.ba-common-listItem.is-selected [type=button]:focus{background-color:#e0e0e0;box-shadow:inset 0 0 0 1px transparent}.selection-mark .ba-common-listItem.is-selected{box-shadow:inset 4px 0 0 0 #0f62fe}.ba-common-listItem.is-separator:after{border-color:#e0e0e0}.ba-common-listItem.is-hoveredBelow:after,.ba-common-listItem.is-hoveredAbove:after{border-color:#1f57a4;border-color:hsla(var(--primary1-h, 214.7368421053), var(--primary1-s, 68.2051282051%), var(--primary1-l, 38.2352941176%), 1)}.ba-common-listItem.is-hoveredCenter{outline-color:#1f57a4;outline-color:hsla(var(--primary1-h, 214.7368421053), var(--primary1-s, 68.2051282051%), var(--primary1-l, 38.2352941176%), 1);border-color:#1f57a4;border-color:hsla(var(--primary1-h, 214.7368421053), var(--primary1-s, 68.2051282051%), var(--primary1-l, 38.2352941176%), 1)}.ba-common-listItem__cmBtn:hover .ba-common-svgIcon{color:#1f57a4;color:hsla(var(--primary1-h, 214.7368421053), var(--primary1-s, 68.2051282051%), var(--primary1-l, 38.2352941176%), 1)}.ba-common-listItem.is-disabled{cursor:not-allowed}.ba-common-listItem__iconBtn:hover .is-icon{color:#1f57a4;color:hsla(var(--primary1-h, 214.7368421053), var(--primary1-s, 68.2051282051%), var(--primary1-l, 38.2352941176%), 1)}body.mobile .ba-common-listItem.is-selected .ba-common-listItem__cmBtn,body.mobile .ba-common-listItem.is-selected .ba-common-listItem__iconBtn{visibility:visible}body:not(.mobile) .ba-common-listItem:hover:not(.is-disabled) .ba-common-listItem__cmBtn,body:not(.mobile) .ba-common-listItem:hover:not(.is-disabled) .ba-common-listItem__iconBtn{visibility:visible}body:not(.mobile) .ba-common-listItem:not(.is-active):hover{background-color:#e5e5e5;color:#161616;border-color:transparent}body:not(.mobile) .ba-common-listItem:not(.is-active):hover [type=button]:focus{background-color:#e5e5e5;box-shadow:inset 0 0 0 1px #e5e5e5}body:not(.mobile) .ba-common-listItem:not(.is-active):hover [type=button]:hover{background-color:transparent;box-shadow:inset 0 0 0 1px transparent}body:not(.mobile) .ba-common-listItem.is-disableHover:hover{background-color:transparent;color:#525252}.ba--highContrast .ba-common-listItem:hover{border-left-style:solid;border-left-width:4px}.ba--highContrast .ba-common-listItem.is-selected{border-left-style:double;border-left-width:4px}@media screen and (-ms-high-contrast: active){.ba--highContrast .ba-common-listItem.is-selected{border:1px solid #fff}}.ba--highContrast .ba-common-listItem.is-active{border-left-style:solid;border-left-width:4px}", ""]);

// exports


/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = __webpack_require__(11);

var _utils = __webpack_require__(5);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  scrollIntoViewIfNeeded,
  isElementInView
} = _utils.domUtils;

class StaticList extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_itemsRenderer", (items, ref) => /*#__PURE__*/_react.default.createElement("div", {
      ref: ref
    }, items));
  }

  componentDidMount() {
    const {
      initialIndex
    } = this.props;

    if (initialIndex > 0) {
      this.scrollTo(initialIndex);
    }
  }

  getVisibleRange() {
    const {
      children
    } = this._container;
    const parent = this.props.getScrollParent();
    let startRange = null;
    let endRange = null;

    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      if (isElementInView(child, parent)) {
        if (startRange == null) {
          startRange = i;
        }

        endRange = i;
      } else if (endRange != null) {
        break;
      }
    }

    return [startRange || 0, endRange || 0];
  }

  scrollAround(index) {
    this._staticScrollTo(index);
  }

  scrollTo(index) {
    this._staticScrollTo(index, true);
  }

  _staticScrollTo(index, scrollTo) {
    if (this._container && index >= 0) {
      const {
        children
      } = this._container;

      if (children.length > index) {
        const child = children[index];

        if (scrollTo) {
          child.parentNode.parentNode.scrollTop = child.offsetTop;
        } else {
          scrollIntoViewIfNeeded(this.props.getScrollParent(), child);
        }
      }
    }
  }

  render() {
    const {
      length,
      itemsRenderer,
      itemRenderer
    } = this.props;
    const containerRenderer = itemsRenderer || this._itemsRenderer;
    const items = [];

    for (let i = 0; i < length; i += 1) {
      items.push(itemRenderer(i, i));
    }

    return containerRenderer(items, itemsContainer => this._container = (0, _reactDom.findDOMNode)(itemsContainer)); // eslint-disable-line no-return-assign
  }

}

exports.default = StaticList;
(0, _defineProperty2.default)(StaticList, "propTypes", {
  length: _propTypes.default.number.isRequired,
  itemsRenderer: _propTypes.default.func,
  itemRenderer: _propTypes.default.func.isRequired,
  initialIndex: _propTypes.default.number,
  getScrollParent: _propTypes.default.func.isRequired
});

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactList = _interopRequireDefault(__webpack_require__(375));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
class VirtualizedList extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_ref", list => {
      this._list = list;
    });
  }

  getVisibleRange() {
    return this._list.getVisibleRange();
  }

  scrollAround(index) {
    const visibleRange = this._list.getVisibleRange();

    if (visibleRange[0] > index) {
      this._list.scrollAround(Math.max(0, Math.ceil(index - (visibleRange[1] - visibleRange[0]) / 2)));
    } else if (visibleRange[1] < index) {
      this._list.scrollAround(Math.min(this.props.length - 1, Math.floor(index + (visibleRange[1] - visibleRange[0]) / 2)));
    } else if (index === visibleRange[0] || index === visibleRange[1]) {
      this._list.scrollAround(index);
    }
  }

  scrollTo(index) {
    this._list.scrollTo(index);
  }

  render() {
    const {
      listType,
      length,
      initialIndex,
      itemSizeGetter,
      itemSizeEstimator,
      itemRenderer,
      itemsRenderer
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_reactList.default, {
      type: listType,
      itemRenderer: itemRenderer,
      itemsRenderer: itemsRenderer,
      length: length,
      initialIndex: initialIndex,
      ref: this._ref,
      itemSizeEstimator: itemSizeEstimator,
      itemSizeGetter: itemSizeGetter
    });
  }

}

exports.default = VirtualizedList;
(0, _defineProperty2.default)(VirtualizedList, "propTypes", {
  length: _propTypes.default.number.isRequired,
  itemRenderer: _propTypes.default.func.isRequired,
  itemsRenderer: _propTypes.default.func,
  initialIndex: _propTypes.default.number,
  listType: _propTypes.default.oneOf(['uniform', 'simple', 'variable']),
  itemSizeEstimator: _propTypes.default.func,
  itemSizeGetter: _propTypes.default.func
});
(0, _defineProperty2.default)(VirtualizedList, "defaultProps", {
  listType: 'uniform',
  selectionMode: 'none'
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_List_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_List_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_List_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_List_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_List_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _button = _interopRequireDefault(__webpack_require__(12));

var _flexlayout = _interopRequireWildcard(__webpack_require__(14));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _overflowMenuVertical_ = _interopRequireDefault(__webpack_require__(66));

var _utils = __webpack_require__(5);

__webpack_require__(377);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  sanitize
} = _utils.propsUtils;

class ListItem extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_onContextMenu", e => {
      this.props.onMenu(e.pageX, e.pageY, e);
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._buttonNode = node;
    });
    (0, _defineProperty2.default)(this, "_iconOnclick", event => {
      const {
        onIconClick
      } = this.props;
      onIconClick(event);
    });
  }

  render() {
    const {
      disableHover,
      hoveredAbove,
      hoveredBelow,
      hoveredActive,
      hoveredCenter,
      hoveredRight,
      hoveredLeft,
      outerClassName,
      className,
      children,
      selected,
      active,
      focus,
      listItemFocus,
      index,
      length,
      selectable,
      separator,
      onMenu,
      actions,
      role,
      icon,
      style,
      disabled,
      ellipsisTitle,
      hideMenuButton,
      showOverflow,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)('ba-common-listItem', {
      hoveredAbove,
      hoveredActive,
      hoveredBelow,
      disableHover: disabled || disableHover,
      hoveredCenter,
      hoveredRight,
      hoveredLeft,
      selectable,
      active: disabled ? false : active,
      focus,
      selected: disabled ? false : selected,
      separator,
      disabled
    });
    const outerClassNames = (0, _utils.classnames)('ba-common-listItem-wrapper ', outerClassName, {
      focus
    });
    const innerClassNames = (0, _utils.classnames)('ba-common-listItem__cmBtn ba-common-listItem-with-right-icon', {
      listItemFocus
    });
    return /*#__PURE__*/_react.default.createElement(_flexlayout.default, (0, _extends2.default)({}, sanitize(others, ListItem), {
      alignItems: "center",
      onContextMenu: onMenu ? this._onContextMenu : null,
      className: `${classNames} ${className}`,
      "aria-setsize": length,
      "aria-posinset": index + 1,
      "aria-selected": !!selected,
      role: role,
      style: style,
      outerClassName: `${outerClassNames}`
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "list-item-children"
    }, children), actions, !icon && onMenu && !hideMenuButton && /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      className: `${innerClassNames}`
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      hasIconOnly: true,
      kind: "ghost",
      size: "small",
      iconDescription: ellipsisTitle // hidden via css
      ,
      tooltipPosition: "left",
      "aria-label": ellipsisTitle,
      disabled: disabled,
      "data-tid": "ba-common-listItem__context-menu",
      "data-list-context-menu": true,
      ref: this._ref,
      onClick: this._onContextMenu,
      renderIcon: () => showOverflow !== false ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        iconId: _overflowMenuVertical_.default.id
      }) : null
    })), icon && /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      className: "ba-common-listItem__iconBtn"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-tid": "ba-common-listItem__button",
      ref: this._ref,
      button: false,
      intent: "",
      size: "small",
      disabled: disabled // List is using _onItemMouseDown and _onItemClick to detact selectChange, if onItemMouseDown listener triggered, onItemClick won't trigger
      // when user click on the custom icon, let the listener run when browser dispatches mousedown event,
      // if necessary, user can stop the mousedown event from bubbling up to list.
      // Also force stop the event from bubbling up to list when browser dispatches click event
      // This way guarantees the list will detect select change once when user click on custom icon
      ,
      onMouseDown: this._iconOnclick,
      onClick: e => e.stopPropagation(),
      variant: "inline",
      icon: icon
    })));
  }

}

exports.default = ListItem;
(0, _defineProperty2.default)(ListItem, "propTypes", {
  className: _propTypes.default.string,
  role: _propTypes.default.string,
  disableHover: _propTypes.default.bool,
  length: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  selected: _propTypes.default.bool,
  active: _propTypes.default.bool,
  focus: _propTypes.default.bool,
  listItemFocus: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  onMenu: _propTypes.default.func,
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  onIconClick: _propTypes.default.func,
  selectable: _propTypes.default.bool,
  separator: _propTypes.default.bool,
  showOverflow: _propTypes.default.bool,
  hoveredAbove: _propTypes.default.bool,
  hoveredBelow: _propTypes.default.bool,
  hoveredCenter: _propTypes.default.bool,
  hoveredRight: _propTypes.default.bool,
  hoveredLeft: _propTypes.default.bool,
  hoveredActive: _propTypes.default.bool,
  actions: _propTypes.default.any,
  style: _propTypes.default.object,
  outerClassName: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  ellipsisTitle: _propTypes.default.string,
  hideMenuButton: _propTypes.default.bool
});
(0, _defineProperty2.default)(ListItem, "defaultProps", {
  role: 'option',
  className: '',
  outerClassName: '',
  style: {}
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__27__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(373);


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;

var _List = _interopRequireWildcard(__webpack_require__(374));

exports.default = _List.default;
exports.List = _List.default;
exports.expandEventTypes = _List.expandEventTypes;
exports.activeEventTypes = _List.activeEventTypes;

var _ListItem = _interopRequireDefault(__webpack_require__(180));

exports.ListItem = _ListItem.default;

var _VirtualizedList = _interopRequireDefault(__webpack_require__(178));

exports.VirtualizedList = _VirtualizedList.default;

var _StaticList = _interopRequireDefault(__webpack_require__(177));

exports.StaticList = _StaticList.default;

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = exports.activeEventTypes = exports.expandEventTypes = exports.selectionEventTypes = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = __webpack_require__(11);

var _utils = __webpack_require__(5);

var _constants = __webpack_require__(27);

var _StaticList = _interopRequireDefault(__webpack_require__(177));

var _VirtualizedList = _interopRequireDefault(__webpack_require__(178));

__webpack_require__(179);

var _DefaultItemRenderer = __webpack_require__(376);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// Constants
const {
  selectionEventTypes
} = _constants.listEventTypes;
exports.selectionEventTypes = selectionEventTypes;
const {
  expandEventTypes
} = _constants.listEventTypes;
exports.expandEventTypes = expandEventTypes;
const {
  activeEventTypes
} = _constants.listEventTypes; // Utils

exports.activeEventTypes = activeEventTypes;
const {
  sanitize
} = _utils.propsUtils;
const {
  getKeyName,
  keyNames,
  isKey
} = _utils.keyboardUtils;
const {
  getElementCenter,
  getElementTopLeft,
  getElementBottomLeft,
  offsetWithinBoundingRect,
  getEventClientOffset,
  IE11
} = _utils.domUtils;
const {
  uniqueId,
  clamp,
  range
} = _utils.lodash;
const VIRTUALIZATION_COUNT = 30;
const LONG_PRESS_TIME = 500;

function isVirtualized(length, virtualized) {
  return virtualized || virtualized !== false && length > VIRTUALIZATION_COUNT;
} // Using this variable to retain value of listItemID to activate focus on ESCAPE.
// Tried using state but it failed to retain state after context menu opened.


let listItemID = ''; // Using this variable to reatin value to check if focus was cicked on mousedown or keypress

let focusEventType = false;

class List extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_itemRenderer", (itemIndex, key) => {
      const itemProps = {
        index: itemIndex,
        active: this.isItemSelected(itemIndex),
        focus: this._isFocusedItem(itemIndex),
        listItemFocus: this._isFocusedListItem(itemIndex),
        key: this.props.getKey ? this.props.getKey(itemIndex) : key,
        id: this._getListItemId(itemIndex),
        length: this.props.length,
        selectable: this.props.selectionMode !== 'none'
      };

      if (this.props.selectionMode !== 'none' && this.props.isSelected) {
        itemProps.selected = this.props.isSelected(itemIndex);
      }

      if (this.props.hierarchical) {
        itemProps.expanded = this.props.isExpanded(itemIndex);
        itemProps.onExpand = this._onItemExpand;
      }

      const itemSpec = this.props.options ? this.props.options[itemIndex] : {};

      const item = this._renderItemUsingRendererPriority(itemSpec, itemProps);

      return this._updateItemWithCallbacks(itemIndex, item);
    });
    (0, _defineProperty2.default)(this, "_renderItemUsingRendererPriority", (itemSpec, itemProps) => {
      if (itemSpec.itemRenderer) {
        const {
          renderConfigs
        } = itemSpec;

        const updatedItemProps = this._updateItemPropsWithCallbacks(itemProps);

        return /*#__PURE__*/_react.default.createElement(itemSpec.itemRenderer, {
          itemSpec: itemSpec,
          itemProps: updatedItemProps,
          renderConfigs: renderConfigs
        });
      }

      const {
        index
      } = itemProps;
      return this.props.itemRenderer ? this.props.itemRenderer(index, itemProps) : /*#__PURE__*/_react.default.createElement(_DefaultItemRenderer.DefaultItemRenderer, {
        itemSpec: itemSpec,
        itemProps: this._updateItemPropsWithCallbacks(itemProps)
      });
    });
    (0, _defineProperty2.default)(this, "_updateItemWithCallbacks", (itemIndex, item) => {
      // TODO: callbacks should be more specific and not override native events
      // ie onDoubleClick -> onExpand
      if (!this._itemsMap[itemIndex]) {
        this._itemsMap[itemIndex] = {
          ref: this._onItemRef.bind(this, itemIndex),
          onClick: this._onItemClick.bind(this, itemIndex),
          onMouseDown: this.props.clickSelection ? null : this._onItemMouseDown.bind(this, itemIndex),
          onTouchStart: this._onItemTouchStart.bind(this, itemIndex),
          onTouchEnd: this._onItemTouchEnd.bind(this, itemIndex),
          onMenu: this._onItemMenu.bind(this, itemIndex),
          onDoubleClick: this._onItemDoubleClick.bind(this, itemIndex),
          item: null,
          itemProps: null
        };
      }

      this._itemsMap[itemIndex].itemProps = item.props;
      const {
        ref,
        onClick,
        onMouseDown,
        onTouchStart,
        onTouchEnd,
        onMenu,
        onDoubleClick
      } = this._itemsMap[itemIndex];
      const cloneProps = {
        ref,
        onClick,
        onMouseDown,
        onTouchStart,
        onTouchEnd
      };

      if (this.props.hierarchical && onDoubleClick) {
        cloneProps.onDoubleClick = onDoubleClick;
      }

      if (item.props.onMenu !== null && (this.props.onMenu || item.props.onMenu) && onMenu) {
        cloneProps.onMenu = onMenu;
      }

      return _react.default.cloneElement(item, cloneProps);
    });
    (0, _defineProperty2.default)(this, "_onItemRef", (index, node) => {
      this._itemsMap[index].item = node;
    });
    (0, _defineProperty2.default)(this, "_getItemNode", index => this._itemsMap[index].item);
    (0, _defineProperty2.default)(this, "_getItemProps", index => this._itemsMap[index].itemProps);
    (0, _defineProperty2.default)(this, "_onItemExpand", (index, expand) => {
      this._notifyExpand(expand ? expandEventTypes.EXPAND : expandEventTypes.COLLAPSE, index);
    });
    (0, _defineProperty2.default)(this, "_onItemDoubleClick", (index, e) => {
      if (!e.isDefaultPrevented() && !e.ctrlKey && !e.metaKey) {
        this._onItemSelect(index, e);
      }

      const {
        onDoubleClick
      } = this._getItemProps(index);

      onDoubleClick && onDoubleClick(e);

      if (!e.isDefaultPrevented()) {
        this.setState({}, () => {
          this._notifyExpand(expandEventTypes.TOGGLE, index);
        });
      }

      e.preventDefault();
    });
    (0, _defineProperty2.default)(this, "_onTouchStart", e => {
      if (e.touches && e.touches.length === 1) {
        this._longPressTimer = setTimeout(() => {
          this.setState({
            toggleOnClick: true
          });
          window.addEventListener('touchend', this._onTouchOutside, true);
        }, LONG_PRESS_TIME);
        this.props.onTouchStartCapture && this.props.onTouchStartCapture(e);
      }
    });
    (0, _defineProperty2.default)(this, "_onTouchOutside", e => {
      if (!offsetWithinBoundingRect(getEventClientOffset(e), this._node.getBoundingClientRect()) || !this._node.contains(e.target)) {
        this._clearLongPress();
      }
    });
    (0, _defineProperty2.default)(this, "_clearLongPress", () => {
      clearTimeout(this._longPressTimer);

      if (this.state.toggleOnClick) {
        window.removeEventListener('touchend', this._onTouchOutside, true);
        this.setState({
          toggleOnClick: false
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onTouchEnd", e => {
      if (!this.state.toggleOnClick) {
        this._clearLongPress();
      }

      this.props.onTouchEndCapture && this.props.onTouchEndCapture(e);
    });
    (0, _defineProperty2.default)(this, "_onTouchMove", e => {
      this._processTouch = false;

      if (!this.state.toggleOnClick) {
        this._clearLongPress();
      }

      this.props.onTouchMoveCapture && this.props.onTouchMoveCapture(e);
    });
    (0, _defineProperty2.default)(this, "_onMouseDown", () => {
      focusEventType = true;
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      this.props.onKeyDown && this.props.onKeyDown(e); // IE11 hack: There's a bug in IE in which the list item steals focus from the List when you click on it.
      // this should not happen as the listItem is a div without a tabIndex, yet in IE it does.
      // The e.target === e.currentTarget check is to ensure that keyDown events that did not occur on the List
      // are not handled (ie; those that occured on an input box within a ListItem), and since the listItem is not
      // the List the key events in IE will not work. Thus we have a second IE11 only condition which allows for
      // the target to be a listItem.

      if (e.target === e.currentTarget || IE11 && e.target.classList && e.target.classList.contains('ba-common-listItem')) {
        this._doOnKeyDown(e);
      }
    });
    (0, _defineProperty2.default)(this, "_getScrollParent", () => this._node);
    (0, _defineProperty2.default)(this, "_onFocus", () => {
      this.setState({
        focused: true
      });
      setTimeout(() => {
        if (!focusEventType) {
          this.setState({
            showFocusClass: true
          });
          focusEventType = false;
        }
      }, 1);
    });
    (0, _defineProperty2.default)(this, "_onScroll", () => {
      this.props.onScrollCloseMenu && this.props.onScrollCloseMenu();

      if (this.props.getMoreData) {
        const scrollParent = this._getScrollParent();

        const pagesRemainingUntilBottom = (scrollParent.scrollHeight - (scrollParent.scrollTop + scrollParent.clientHeight)) / scrollParent.clientHeight;

        if (pagesRemainingUntilBottom <= 3) {
          this.props.getMoreData();
        }
      }
    });
    (0, _defineProperty2.default)(this, "_onKeyUp", e => {
      if (isKey(e, keyNames.TAB)) {
        this.setState({
          showFocusClass: true
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onBlur", () => {
      if (this.props.toggleContextMenu) {
        console.warn('The property toggleContextMenu will be deprecated soon.'); // eslint-disable-line

        this.props.toggleContextMenu();
      }

      this.setState({
        showFocusClass: false,
        showListItemFocus: false
      });
      this.setState({
        focused: false
      });
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
    (0, _defineProperty2.default)(this, "_refList", list => {
      this._list = list;
    });
    let active = props.initialIndex != null ? props.initialIndex : -1;

    if (props.activeIndex != null) {
      active = props.activeIndex;
    }

    this.state = {
      focused: false,
      pivot: active,
      lastClick: active,
      active,
      toggleOnClick: false,
      showFocusClass: false,
      showListItemFocus: false
    };
    this._id = uniqueId('__list_');
    this._itemsMap = {};
  }

  componentWillReceiveProps({
    activeIndex,
    lastClickIndex,
    pivotIndex,
    length,
    virtualized
  }) {
    if (this._isVirtualized() !== isVirtualized(length, virtualized)) {
      this._prevScrollTop = this._node.scrollTop;
    }

    if (activeIndex != null) {
      let lastClick = lastClickIndex;
      let pivot = pivotIndex;

      if (lastClick == null || lastClick === -1) {
        lastClick = 0;
      }

      if (pivot == null || pivot === -1) {
        pivot = 0;
      }

      this.setState({
        active: activeIndex,
        lastClick,
        pivot
      });
    } else if (length < this.props.length && this.state.active >= length) {
      this.setState({
        active: length - 1,
        pivot: length - 1,
        lastClick: length - 1
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this._prevScrollTop) {
      requestAnimationFrame(() => {
        this._node && (this._node.scrollTop = this._prevScrollTop);
        this._prevScrollTop = null;

        if (this._isVirtualized()) {
          // force firing a scroll event immediately to avoid flickering
          const event = document.createEvent('Event');
          event.initEvent('scroll', true, false);
          this._node && this._node.dispatchEvent(event);
        }

        if (this.props.activeIndex == null && this.state.active !== prevState.active) {
          this.scrollAround(this.state.active);
        }
      });
    } else if (this.props.activeIndex == null && this.state.active !== prevState.active) {
      this.scrollAround(this.state.active);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('touchend', this._onTouchOutside, true);
    clearTimeout(this._longPressTimer);
  }

  getActiveIndex() {
    return this.state.active;
  }

  getVisibleRange() {
    return this._list.getVisibleRange();
  }

  _isFocusedItem(index) {
    /* Set focus state to first item in list if no active index is present */
    if (index === 0 && this._getActiveIndex() < 0 && this.state.showFocusClass) {
      return true;
    }

    return (this.props.alwaysDisplayActive || this.state.focused) && this._getActiveIndex() === index && this.state.showFocusClass;
  }

  _isFocusedListItem(index) {
    return this._getActiveIndex() === index && this.state.showListItemFocus;
  }

  handleKeyEvent(e) {
    this._doOnKeyDown(e);
  }

  scrollAround(index) {
    this._list.scrollAround(index);

    if (this.props.activeIndex == null) {
      this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

      this.setState({
        active: index,
        pivot: index,
        lastClick: index
      });
    }
  }

  scrollTo(index) {
    this._list.scrollTo(index);

    if (this.props.activeIndex == null) {
      this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

      if (this.props.selectionMode === 'none') {
        this.setState({
          active: index,
          pivot: index,
          lastClick: index
        });
      }
    }
  }

  isItemSelected(index) {
    const {
      selectionMode,
      alwaysDisplayActive
    } = this.props;
    /* NOTE: when selectionMode is none, make keyboard navigation still available if needed by setting alwaysDisplayActive = true */

    if (selectionMode === 'none' && !alwaysDisplayActive) {
      return false;
    }

    return (alwaysDisplayActive || this.state.focused) && this._getActiveIndex() === index;
  }

  _updateItemPropsWithCallbacks(itemProps) {
    return { ...itemProps,
      ref: this._onItemRef.bind(this, itemProps.index),
      onClick: this._onItemClick.bind(this, itemProps.index),
      onMouseDown: this.props.clickSelection ? null : this._onItemMouseDown.bind(this, itemProps.index),
      onTouchStart: this._onItemTouchStart.bind(this, itemProps.index),
      onTouchEnd: this._onItemTouchEnd.bind(this, itemProps.index),
      onMenu: itemProps.onMenu && this._onItemMenu.bind(this, itemProps.index),
      onDoubleClick: this._onItemDoubleClick.bind(this, itemProps.index)
    };
  }

  _getActiveIndex() {
    return this.props.activeIndex == null ? this.state.active : this.props.activeIndex;
  }

  _getListItemId(index) {
    return `${this._id}_${this.props.getItemId ? this.props.getItemId(index) : index}`;
  }

  _isToggleOnClick() {
    return this.state.toggleOnClick || this.props.toggleOnClick;
  }

  _onItemMenu(index, x, y, e) {
    const {
      onMenu
    } = this._getItemProps(index); // TODO if the user right clicked a selected element then we do not want to redo the selection


    if (this.props.isSelected && this.props.isSelected(index)) {
      e.stopPropagation();
    } else if (e.isDefaultPrevented()) {
      this.setState({
        active: index,
        lastClick: index,
        pivot: index
      });

      this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

      this._notifySelectionChange(selectionEventTypes.SET, index);
    } else if (!e.ctrlKey && !e.metaKey && (!this.props.isSelected || !this.props.isSelected(index))) {
      this._onItemSelect(index, e);
    }

    e.preventDefault(); // adjust x, y if outside of list bounds

    const bounds = this._node.getBoundingClientRect();

    const adjustedX = Math.max(bounds.left, Math.min(x, bounds.right));
    const adjustedY = Math.max(bounds.top, Math.min(y, bounds.bottom));
    onMenu && onMenu(adjustedX, adjustedY, e, index);
    e.persist();
    this.setState({}, () => {
      this.props.onMenu && this.props.onMenu(adjustedX, y, e, index);
    });
  }

  _onItemTouchStart(index, e) {
    this._processTouch = e.touches.length === 1;

    const {
      onTouchStart
    } = this._getItemProps(index);

    onTouchStart && onTouchStart(e);
  }

  _onItemTouchEnd(index, e) {
    this._handledByTouchStart = false;
    this._handledByMouseDown = false;

    if (this._processTouch && this.props.isSelected && !this.props.isSelected(index)) {
      this._onItemSelect(index, e);

      this._handledByTouchStart = true;
    }

    const {
      onTouchEnd
    } = this._getItemProps(index);

    onTouchEnd && onTouchEnd(e);
  }

  _onItemMouseDown(index, e) {
    this._handledByMouseDown = false;

    if (!this._handledByTouchStart) {
      if (this.props.isSelected && !this.props.isSelected(index)) {
        this._onItemSelect(index, e);

        this._handledByMouseDown = true;
      }

      const {
        onMouseDown
      } = this._getItemProps(index);

      onMouseDown && onMouseDown(e);
    } else {
      // Need this here in case user switches between tap and mouse interfaces (ie. touchscreen laptop)
      this._handledByTouchStart = false;
      this._handledByMouseDown = true;
    }
  }

  _onItemClick(index, e) {
    this.setState({
      showFocusClass: false,
      firstSelectedIndex: index,
      showListItemFocus: false
    });

    this._onItemSelect(index, e);
  }

  _onItemSelect(index, e) {
    const {
      selectionMode
    } = this.props;

    if (selectionMode === 'disabled' || this._handledByMouseDown || this._handledByTouchStart) {
      return;
    }

    const newState = {
      active: index,
      lastClick: index
    };

    if (e.shiftKey) {
      e.preventDefault(); // prevent unwanted higlighting in IE
    }

    if (selectionMode === 'single' || selectionMode === 'none') {
      if (e.ctrlKey || e.metaKey) {
        this._notifySelectionChange(selectionEventTypes.TOGGLE, index);
      } else {
        this._notifySelectionChange(selectionEventTypes.SET, index);
      }
    } else if (selectionMode === 'multi') {
      if (e.ctrlKey || e.metaKey) {
        this._notifySelectionChange(selectionEventTypes.TOGGLE, index, true);

        newState.pivot = index;
      } else if (e.shiftKey) {
        this._rangeChange(index);
      } else {
        this._notifySelectionChange(this._isToggleOnClick() ? selectionEventTypes.TOGGLE : selectionEventTypes.SET, index, true);

        newState.pivot = index;
      }
    }

    this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

    this.setState(newState);
  }

  _doOnKeyDown(e) {
    const {
      length,
      selectionMode,
      hierarchical,
      onExpand,
      isExpanded,
      onMenu
    } = this.props;
    const {
      pivot,
      active,
      lastClick,
      firstSelectedIndex,
      showListItemFocus
    } = this.state;
    const {
      F10,
      LEFT,
      RIGHT,
      ESCAPE,
      A,
      HOME,
      UP,
      END,
      DOWN,
      ENTER,
      SPACE,
      TAB
    } = keyNames;
    const newState = {};
    let expandFlag;
    let activeEventType; // set the new active node up or down

    let i = active;

    switch (getKeyName(e)) {
      case F10:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });

        if (e.shiftKey && selectionMode !== 'none' && selectionMode !== 'disabled') {
          e.preventDefault();

          const [startRange, endRange] = this._list.getVisibleRange();

          this._doKeyMenu(this._itemsMap, lastClick, startRange, endRange, this.props.onMenu);
        }

        break;

      case LEFT:
        if (showListItemFocus) {
          this.setState({
            showFocusClass: true,
            showListItemFocus: false
          });
        } else if (!e.shiftKey && hierarchical && i >= 0) {
          if (isExpanded(i)) {
            e.preventDefault();
            expandFlag = false;
          } else if (i > 0) {
            i = this.props.getParentIndex(i);
            activeEventType = activeEventTypes.ABSOLUTE;
          }
        }

        break;

      case RIGHT:
        // on right expand if children exists
        // on right goto button if expand is true
        // on right goto button if children does not exists
        if (isExpanded(i)) {
          this.setState({
            showFocusClass: false,
            showListItemFocus: true
          });
        } else if (!e.shiftKey && hierarchical && i >= 0) {
          e.preventDefault();
          expandFlag = true;
        } else if (onMenu) {
          this.setState({
            showFocusClass: false,
            showListItemFocus: true
          });
        }

        break;

      case ESCAPE:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });
        i = -1;
        activeEventType = activeEventTypes.ABSOLUTE;

        if (listItemID) {
          const ele = document.getElementById(listItemID).parentNode.parentNode.parentNode.parentNode.parentNode;
          ele.focus();
          focusEventType = false;
        }

        break;

      case A:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });

        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();

          if (selectionMode === 'multi') {
            this._notifySelectionChange(selectionEventTypes.SELECT_ALL, null);
          }
        }

        break;

      case HOME: // fall through to arrow up
      // eslint-disable-next-line no-fallthrough

      case UP:
        e.preventDefault();

        if (e.altKey || isKey(e, HOME)) {
          if (i === 0) {
            return;
          }

          i = 0;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i === -1) {
          i = length - 1;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i <= 0) {
          return;
        } else {
          i -= 1;
          activeEventType = activeEventTypes.UP;
        }

        if (e.shiftKey) {
          if (selectionMode === 'single') {
            this._notifySelectionChange(selectionEventTypes.SET, i);
          } else if (selectionMode === 'multi') {
            if (e.altKey) {
              this._rangeChange(i);
            } else if (active <= pivot && firstSelectedIndex >= active) {
              this._notifySelectionChange(selectionEventTypes.ADD, active);

              this._notifySelectionChange(selectionEventTypes.ADD, active - 1);
            } else {
              this._notifySelectionChange(selectionEventTypes.REMOVE, active);
            }
          }

          newState.lastClick = i;
        }

        break;

      case END: // fall through to arrow down
      // eslint-disable-next-line no-fallthrough

      case DOWN:
        e.preventDefault();

        if (e.altKey || isKey(e, END)) {
          if (i === length - 1) {
            return;
          }

          i = length - 1;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i === -1) {
          i = 0;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i >= length - 1) {
          return;
        } else {
          activeEventType = activeEventTypes.DOWN;
          i += 1;
        }

        if (e.shiftKey) {
          if (selectionMode === 'single') {
            this._notifySelectionChange(selectionEventTypes.SET, i);
          } else if (selectionMode === 'multi') {
            if (e.altKey) {
              this._rangeChange(i);
            } else if (active >= pivot && firstSelectedIndex <= active) {
              this._notifySelectionChange(selectionEventTypes.ADD, active);

              this._notifySelectionChange(selectionEventTypes.ADD, active + 1);
            } else {
              this._notifySelectionChange(selectionEventTypes.REMOVE, active);
            }
          }

          newState.lastClick = i;
        }

        break;

      case ENTER:
        if (showListItemFocus) {
          this._notifySelectionChange(selectionEventTypes.SET, i);

          const bounds = this._node.getBoundingClientRect();

          const listItemId = this._getListItemId(i);

          listItemID = this._getListItemId(i);
          const element = document.getElementById(listItemId);
          const PageX = window.pageXOffset + element.getBoundingClientRect().left;
          const PageY = window.pageYOffset + element.getBoundingClientRect().top;
          const adjustedX = Math.max(bounds.left, Math.min(PageX, bounds.right)); // For Defect 253298: Pass in menu button element to callback when triggered by enter key.
          // Regression test: Trigger context menu via enter key near edge of the page in admin or MUI.

          const menuBtn = {
            target: element.querySelector('[data-tid="ba-common-listItem__context-menu"]') // get menu button element to pass as the trigger node for context menu callback

          };
          this.setState({
            active: i,
            lastClick: i,
            pivot: i
          }, () => {
            this.props.onMenu && this.props.onMenu(adjustedX, PageY, menuBtn);
          });
          break;
        }

      // fall through to space
      // eslint-disable-next-line no-fallthrough

      case SPACE:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });
        e.preventDefault();

        if (i >= 0) {
          if (selectionMode === 'single') {
            this._notifySelectionChange(selectionEventTypes.SET, i, true);

            newState.pivot = i;
          } else if (selectionMode === 'multi') {
            if (e.shiftKey) {
              this._rangeChange(i);
            } else if (e.ctrlKey || e.metaKey) {
              this._notifySelectionChange(selectionEventTypes.TOGGLE, i, true);

              newState.pivot = i;
            } else {
              this._notifySelectionChange(this._isToggleOnClick() ? selectionEventTypes.TOGGLE : selectionEventTypes.SET, i, true);

              newState.pivot = i;
            }
          }
        }

        newState.lastClick = i;
        break;

      case TAB:
        this.setState({
          showFocusClass: true
        });
        listItemID = null;
        break;

      default:
        break;
    }

    if (activeEventType) {
      this._notifyActiveChange(activeEventType, i);

      newState.active = i;
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }

    if (hierarchical && expandFlag != null && onExpand && i >= 0) {
      this._notifyExpand(expandFlag ? expandEventTypes.EXPAND : expandEventTypes.COLLAPSE, i);
    }
  }

  _doKeyMenu(visibleItems, selectedIndex, lowerRange, upperRange, onMenu) {
    if (selectedIndex < lowerRange) {
      // top of list
      const {
        x,
        y
      } = getElementTopLeft(this._node);
      onMenu && onMenu(x, y);
    } else if (selectedIndex > upperRange) {
      // bottom of list
      const {
        x,
        y
      } = getElementBottomLeft(this._node);
      onMenu && onMenu(x, y);
    } else {
      // item is within view, get its dom node, fire on it
      const selectedItem = visibleItems[selectedIndex].item;

      if (selectedItem) {
        const element = (0, _reactDom.findDOMNode)(selectedItem);
        const contextMenuElement = element.querySelector('[data-list-context-menu]') || element;
        const {
          x,
          y
        } = getElementCenter(contextMenuElement);
        onMenu && onMenu(x, y);
      }
    }
  }

  _rangeChange(index) {
    const lastIndex = this.props.length - 1;
    const pivot = clamp(this.state.pivot, 0, lastIndex);
    const lastClick = clamp(this.state.lastClick, 0, lastIndex);
    const belowPivot = index > pivot;
    const belowLastClick = index > lastClick;
    let added;
    let removed; // There are 3!=6 possible arrangements of index, pivot and lastClick
    // below are the 6 branches (min/max counted) covering each arrangement

    if (belowPivot && belowLastClick) {
      removed = range(Math.min(pivot, lastClick), pivot);
      added = range(pivot, index + 1);
    } else if (belowPivot && !belowLastClick) {
      removed = range(index + 1, lastClick + 1);
      added = range(pivot, index + 1);
    } else if (belowLastClick) {
      removed = range(lastClick, index);
      added = range(index, pivot + 1);
    } else {
      removed = range(Math.max(pivot, lastClick), pivot);
      added = range(pivot, index - 1);
    }

    if (this.props.onSelectionChange && (removed.length || added.length)) {
      const itemProps = this._getItemProps(index);

      const {
        disabled
      } = itemProps;
      this.props.onSelectionChange({
        type: selectionEventTypes.COMPOSITE,
        added,
        removed,
        last: index,
        disabled: !!disabled
      });
    }
  }

  _notifyExpand(type, index) {
    if (this.props.onExpand) {
      this.props.onExpand({
        type,
        index
      });
    }
  }

  _notifySelectionChange(type, index, pivot = false) {
    if ((!Array.isArray(index) || index.length > 0) && this.props.onSelectionChange) {
      let disabled;

      if (type !== 'select_all') {
        var _this$_getItemNode, _this$_getItemNode$pr;

        disabled = (_this$_getItemNode = this._getItemNode(index)) == null ? void 0 : (_this$_getItemNode$pr = _this$_getItemNode.props) == null ? void 0 : _this$_getItemNode$pr.disabled;
      } else {
        disabled = false;
      }

      this.props.onSelectionChange({
        type,
        index,
        pivot,
        last: index,
        disabled: !!disabled
      });
    }
  }

  _notifyActiveChange(type, index) {
    const {
      onActiveChange
    } = this.props;

    if (onActiveChange && (type !== activeEventTypes.ABSOLUTE || this.state.active !== index)) {
      onActiveChange({
        type,
        index,
        prevIndex: this.state.active
      });
    }
  }

  _isVirtualized() {
    return isVirtualized(this.props.length, this.props.virtualized);
  }

  focus() {
    this._node && this._node.focus();
  }

  render() {
    const {
      className,
      listType,
      length,
      initialIndex,
      selectionMode,
      role,
      hierarchical,
      tabIndex,
      itemSizeGetter,
      itemSizeEstimator,
      itemsRenderer,
      overflowX,
      overflowY,
      fullHeight,
      style,
      selectionMark,
      ...others
    } = this.props;
    const {
      active
    } = this.state;
    const classNames = (0, _utils.classnames)('ba-common-list', 'ba--focusable', {
      selectable: selectionMode !== 'none',
      'selection-mark': selectionMark
    });
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/aria-activedescendant-has-tabindex
      _react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, List), {
        ref: this._ref,
        className: `${classNames} ${className}`,
        id: this._getListItemId(),
        role: role || (hierarchical ? 'tree' : 'listbox'),
        tabIndex: tabIndex,
        onKeyDown: this._onKeyDown,
        onMouseDown: this._onMouseDown,
        onKeyUp: this._onKeyUp,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onTouchStartCapture: this._onTouchStart,
        onTouchEndCapture: this._onTouchEnd,
        onTouchMoveCapture: this._onTouchMove,
        onScroll: this._onScroll,
        "aria-activedescendant": active >= 0 ? this._getListItemId(active) : null,
        "aria-multiselectable": selectionMode === 'multi',
        style: {
          overflowX,
          overflowY,
          height: fullHeight ? '100%' : 'auto',
          ...style
        }
      }), this._isVirtualized() ? /*#__PURE__*/_react.default.createElement(_VirtualizedList.default, {
        id: this._getListItemId(),
        listType: listType,
        itemRenderer: this._itemRenderer,
        itemsRenderer: itemsRenderer,
        length: length,
        initialIndex: initialIndex,
        ref: this._refList,
        itemSizeEstimator: itemSizeEstimator,
        itemSizeGetter: itemSizeGetter
      }) : /*#__PURE__*/_react.default.createElement(_StaticList.default, {
        itemRenderer: this._itemRenderer,
        itemsRenderer: itemsRenderer,
        length: length,
        initialIndex: initialIndex,
        ref: this._refList,
        getScrollParent: this._getScrollParent
      }))
    );
  }

}

exports.default = List;
(0, _defineProperty2.default)(List, "propTypes", {
  activeIndex: _propTypes.default.number,
  alwaysDisplayActive: _propTypes.default.bool,
  className: _propTypes.default.string,
  clickSelection: _propTypes.default.bool,
  fullHeight: _propTypes.default.bool,
  getItemId: _propTypes.default.func,
  getKey: _propTypes.default.func,
  getMoreData: _propTypes.default.func,
  getParentIndex: _propTypes.default.func,
  hierarchical: _propTypes.default.bool,
  initialIndex: _propTypes.default.number,
  isExpanded: _propTypes.default.func,
  isSelected: _propTypes.default.func,
  itemSizeEstimator: _propTypes.default.func,
  itemSizeGetter: _propTypes.default.func,
  itemRenderer: _propTypes.default.func,
  itemsRenderer: _propTypes.default.func,
  lastClickIndex: _propTypes.default.number,
  length: _propTypes.default.number.isRequired,
  listType: _propTypes.default.oneOf(['uniform', 'simple', 'variable']),
  menuProps: _propTypes.default.object,
  onActiveChange: _propTypes.default.func,
  onExpand: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onMenu: _propTypes.default.func,
  onScrollCapture: _propTypes.default.func,
  onScrollCloseMenu: _propTypes.default.func,
  onSelectionChange: _propTypes.default.func,
  onTouchEndCapture: _propTypes.default.func,
  onTouchMoveCapture: _propTypes.default.func,
  onTouchStartCapture: _propTypes.default.func,
  options: _propTypes.default.array,
  overflowX: _propTypes.default.string,
  overflowY: _propTypes.default.string,
  pivotIndex: _propTypes.default.number,
  role: _propTypes.default.string,
  selectionMode: _propTypes.default.oneOf(['none', 'disabled', 'single', 'multi']),
  style: _propTypes.default.object,
  tabIndex: _propTypes.default.oneOf([0, -1]),
  toggleContextMenu: _propTypes.default.func,
  toggleOnClick: _propTypes.default.bool,
  virtualized: _propTypes.default.bool,
  selectionMark: _propTypes.default.bool
});
(0, _defineProperty2.default)(List, "defaultProps", {
  listType: 'uniform',
  selectionMode: 'none',
  tabIndex: 0,
  className: '',
  style: {}
});

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

module.exports = require("react-list");

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.DefaultItemRenderer = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _flexlayout = __webpack_require__(14);

var _utils = __webpack_require__(5);

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _truncatedtext = _interopRequireDefault(__webpack_require__(13));

var _ListItem = _interopRequireDefault(__webpack_require__(180));

var _List = _interopRequireDefault(__webpack_require__(179));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const MenuClassName = _List.default.menuClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils; // eslint-disable-next-line react/prop-types

function createIcon({
  className,
  iconId,
  disabled
}) {
  return /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: (0, _utils.classnames)(`${className}__icon`),
    iconId: iconId,
    size: "small",
    disabled: disabled
  });
}

const DefaultItemRenderer = props => {
  const {
    itemProps,
    itemSpec
  } = props;
  const {
    label,
    disabled,
    icon: _leftIcon,
    rightIcon: _rightIcon,
    ...others
  } = itemSpec;
  const leftIcon = _leftIcon ? createIcon({
    className: MenuClassName,
    iconId: _leftIcon.id,
    disabled
  }) : null;
  const rightIcon = _rightIcon ? createIcon({
    className: MenuClassName,
    iconId: _rightIcon.id,
    disabled
  }) : null;
  const listItemProps = {
    disabled,
    className: (0, _utils.classnames)(`${MenuClassName}__item`),
    ...itemProps,
    ...sanitize(others, null, 'id', 'value')
  };
  const flexItemProps = {
    grow: true,
    basis: 'auto',
    className: (0, _utils.classnames)(`${MenuClassName}__item--text`)
  };
  const textProps = {
    className: 'cursor',
    value: label,
    location: 'middle',
    disabled
  };
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, listItemProps, leftIcon, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, flexItemProps, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, textProps)), rightIcon);
};

exports.DefaultItemRenderer = DefaultItemRenderer;
DefaultItemRenderer.propTypes = {
  itemSpec: _propTypes.default.object,
  itemProps: _propTypes.default.object
};

/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ListItem_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(118);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ListItem_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ListItem_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ListItem_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ListItem_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[372,0]]]);
});